import { Col, Flex, Row, Statistic, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { totalUploadedRows } from '../../utils/step-display';
import type { ParsedJsonUpload } from '../../types';
import { PIPELINE_STEP_IDS } from '../../types';

const { Paragraph, Title } = Typography;

type PipelineDebugHeaderProps = {
  uploads: ParsedJsonUpload[];
  completedSteps: number;
};

export function PipelineDebugHeader({
  uploads,
  completedSteps,
}: PipelineDebugHeaderProps) {
  const { t } = useTranslation('pipelineDebug');
  const rowCount = totalUploadedRows(uploads);

  return (
    <div className="pipeline-debug-header">
      <Flex justify="space-between" align="flex-start" wrap gap={16}>
        <Flex vertical gap={4} style={{ flex: 1, minWidth: 240 }}>
          <Title level={2} style={{ margin: 0 }}>
            {t('title')}
          </Title>
          <Paragraph type="secondary" style={{ margin: 0, maxWidth: 520 }}>
            {t('subtitle')}
          </Paragraph>
        </Flex>
        <Row gutter={12} className="pipeline-debug-kpis">
          <Col>
            <div className="pipeline-debug-kpi pipeline-debug-kpi--blue">
              <Statistic title={t('kpis.files')} value={uploads.length} />
            </div>
          </Col>
          <Col>
            <div className="pipeline-debug-kpi pipeline-debug-kpi--green">
              <Statistic title={t('kpis.logRows')} value={rowCount} />
            </div>
          </Col>
          <Col>
            <div className="pipeline-debug-kpi pipeline-debug-kpi--violet">
              <Statistic
                title={t('kpis.progress')}
                value={completedSteps}
                suffix={`/ ${PIPELINE_STEP_IDS.length}`}
              />
            </div>
          </Col>
        </Row>
      </Flex>
    </div>
  );
}
